const squareAvatarListFirstTwoItems = [
  { x: 0, y: 0, rx: 2, ry: 2, width: 32, height: 32 },
  { x: 42, y: 0, rx: 2, ry: 2, width: 100, height: 12 },
  { x: 42, y: 18, rx: 2, ry: 2, width: 58, height: 12 },

  { x: 0, y: 48, rx: 2, ry: 2, width: 32, height: 32 },
  { x: 42, y: 48, rx: 2, ry: 2, width: 100, height: 12 },
  { x: 42, y: 66, rx: 2, ry: 2, width: 58, height: 12 },
]

export default {
  'join-request-card': {
    props: { height: 150, width: 250 },
    items: [
      { x: 0, y: 0, rx: 2, ry: 2, width: 32, height: 32 },
      { x: 42, y: 0, rx: 2, ry: 2, width: 100, height: 12 },
      { x: 42, y: 18, rx: 2, ry: 2, width: 58, height: 12 },

      { x: 0, y: 42, rx: 2, ry: 2, width: 133.33, height: 75 },
      { x: 143.33, y: 42, rx: 2, ry: 2, width: 58, height: 12 },
      { x: 143.33, y: 60.75, rx: 2, ry: 2, width: 100, height: 12 },
      { x: 143.33, y: 79.5, rx: 2, ry: 2, width: 90, height: 12 },
      { x: 143.33, y: 98.25, rx: 2, ry: 2, width: 80, height: 12 },
      { x: 0, y: 120.25, rx: 2, ry: 2, width: 58, height: 24 },
      { x: 68, y: 154.25, rx: 2, ry: 2, width: 58, height: 24 },
    ],
  },
  'square-avatar-list': {
    props: { height: 130, width: 240 },
    items: [
      ...squareAvatarListFirstTwoItems,

      { x: 0, y: 96, rx: 2, ry: 2, width: 32, height: 32 },
      { x: 42, y: 96, rx: 2, ry: 2, width: 100, height: 12 },
      { x: 42, y: 114, rx: 2, ry: 2, width: 58, height: 12 },
    ],
  },
  'square-avatar-list-two-items': {
    props: { height: 80, width: 240 },
    items: squareAvatarListFirstTwoItems,
  },
  'circle-avatar-list': {
    props: { height: 156, width: 240 },
    items: [
      { x: 0, y: 0, rx: 20, ry: 20, width: 40, height: 40 },
      { x: 56, y: 4, rx: 2, ry: 2, width: 100, height: 12 },
      { x: 56, y: 22, rx: 2, ry: 2, width: 58, height: 12 },

      { x: 0, y: 56, rx: 20, ry: 20, width: 40, height: 40 },
      { x: 56, y: 60, rx: 2, ry: 2, width: 100, height: 12 },
      { x: 56, y: 78, rx: 2, ry: 2, width: 58, height: 12 },

      { x: 0, y: 112, rx: 20, ry: 20, width: 40, height: 40 },
      { x: 56, y: 116, rx: 2, ry: 2, width: 100, height: 12 },
      { x: 56, y: 134, rx: 2, ry: 2, width: 58, height: 12 },
    ],
  },
  'square-avatar-table-2-cols-560': {
    props: { height: 80, width: 560 },
    items: [
      ...squareAvatarListFirstTwoItems,
      { x: 340, y: 0, rx: 2, ry: 2, width: 40, height: 12 },
      { x: 500, y: 0, rx: 2, ry: 2, width: 40, height: 12 },
      { x: 340, y: 42, rx: 2, ry: 2, width: 40, height: 12 },
      { x: 500, y: 42, rx: 2, ry: 2, width: 40, height: 12 },
    ],
  },
  'square-avatar-table': {
    props: { height: 224, width: 840 },
    items: [
      { x: 0, y: 0, rx: 2, ry: 2, width: 32, height: 32 },
      { x: 42, y: 0, rx: 2, ry: 2, width: 112, height: 12 },
      { x: 42, y: 18, rx: 2, ry: 2, width: 55, height: 12 },
      { x: 256, y: 9, rx: 2, ry: 2, width: 148, height: 12 },
      { x: 482, y: 9, rx: 2, ry: 2, width: 56, height: 12 },
      { x: 657, y: 9, rx: 2, ry: 2, width: 56, height: 12 },
      { x: 776, y: 9, rx: 2, ry: 2, width: 81, height: 12 },

      { x: 0, y: 48, rx: 2, ry: 2, width: 32, height: 32 },
      { x: 42, y: 48, rx: 2, ry: 2, width: 112, height: 12 },
      { x: 42, y: 66, rx: 2, ry: 2, width: 55, height: 12 },
      { x: 256, y: 57, rx: 2, ry: 2, width: 148, height: 12 },
      { x: 482, y: 57, rx: 2, ry: 2, width: 56, height: 12 },
      { x: 657, y: 57, rx: 2, ry: 2, width: 56, height: 12 },
      { x: 776, y: 57, rx: 2, ry: 2, width: 81, height: 12 },

      { x: 0, y: 96, rx: 2, ry: 2, width: 32, height: 32 },
      { x: 42, y: 96, rx: 2, ry: 2, width: 112, height: 12 },
      { x: 42, y: 114, rx: 2, ry: 2, width: 55, height: 12 },
      { x: 256, y: 105, rx: 2, ry: 2, width: 148, height: 12 },
      { x: 482, y: 105, rx: 2, ry: 2, width: 56, height: 12 },
      { x: 657, y: 105, rx: 2, ry: 2, width: 56, height: 12 },
      { x: 776, y: 105, rx: 2, ry: 2, width: 81, height: 12 },

      { x: 0, y: 144, rx: 2, ry: 2, width: 32, height: 32 },
      { x: 42, y: 144, rx: 2, ry: 2, width: 112, height: 12 },
      { x: 42, y: 162, rx: 2, ry: 2, width: 55, height: 12 },
      { x: 256, y: 153, rx: 2, ry: 2, width: 148, height: 12 },
      { x: 482, y: 153, rx: 2, ry: 2, width: 56, height: 12 },
      { x: 657, y: 153, rx: 2, ry: 2, width: 56, height: 12 },
      { x: 776, y: 153, rx: 2, ry: 2, width: 81, height: 12 },

      { x: 0, y: 192, rx: 2, ry: 2, width: 32, height: 32 },
      { x: 42, y: 192, rx: 2, ry: 2, width: 112, height: 12 },
      { x: 42, y: 210, rx: 2, ry: 2, width: 55, height: 12 },
      { x: 256, y: 201, rx: 2, ry: 2, width: 148, height: 12 },
      { x: 482, y: 201, rx: 2, ry: 2, width: 56, height: 12 },
      { x: 657, y: 201, rx: 2, ry: 2, width: 56, height: 12 },
      { x: 776, y: 201, rx: 2, ry: 2, width: 81, height: 12 },
    ],
  },
  'square-avatar-table-full-width': {
    props: { height: 224, width: 1162 },
    items: [
      { x: 0, y: 0, rx: 2, ry: 2, width: 32, height: 32 },
      { x: 42, y: 0, rx: 2, ry: 2, width: 112, height: 12 },
      { x: 42, y: 18, rx: 2, ry: 2, width: 55, height: 12 },
      { x: 256, y: 9, rx: 2, ry: 2, width: 148, height: 12 },
      { x: 482, y: 9, rx: 2, ry: 2, width: 56, height: 12 },
      { x: 620, y: 9, rx: 2, ry: 2, width: 112, height: 12 },
      { x: 810, y: 9, rx: 2, ry: 2, width: 130, height: 12 },
      { x: 1062, y: 9, rx: 2, ry: 2, width: 100, height: 12 },

      { x: 0, y: 48, rx: 2, ry: 2, width: 32, height: 32 },
      { x: 42, y: 48, rx: 2, ry: 2, width: 112, height: 12 },
      { x: 42, y: 66, rx: 2, ry: 2, width: 55, height: 12 },
      { x: 256, y: 57, rx: 2, ry: 2, width: 148, height: 12 },
      { x: 482, y: 57, rx: 2, ry: 2, width: 56, height: 12 },
      { x: 620, y: 57, rx: 2, ry: 2, width: 112, height: 12 },
      { x: 810, y: 57, rx: 2, ry: 2, width: 130, height: 12 },
      { x: 1062, y: 57, rx: 2, ry: 2, width: 100, height: 12 },

      { x: 0, y: 96, rx: 2, ry: 2, width: 32, height: 32 },
      { x: 42, y: 96, rx: 2, ry: 2, width: 112, height: 12 },
      { x: 42, y: 114, rx: 2, ry: 2, width: 55, height: 12 },
      { x: 256, y: 105, rx: 2, ry: 2, width: 148, height: 12 },
      { x: 482, y: 105, rx: 2, ry: 2, width: 56, height: 12 },
      { x: 620, y: 105, rx: 2, ry: 2, width: 112, height: 12 },
      { x: 810, y: 105, rx: 2, ry: 2, width: 130, height: 12 },
      { x: 1062, y: 105, rx: 2, ry: 2, width: 100, height: 12 },

      { x: 0, y: 144, rx: 2, ry: 2, width: 32, height: 32 },
      { x: 42, y: 144, rx: 2, ry: 2, width: 112, height: 12 },
      { x: 42, y: 162, rx: 2, ry: 2, width: 55, height: 12 },
      { x: 256, y: 153, rx: 2, ry: 2, width: 148, height: 12 },
      { x: 482, y: 153, rx: 2, ry: 2, width: 56, height: 12 },
      { x: 620, y: 153, rx: 2, ry: 2, width: 112, height: 12 },
      { x: 810, y: 153, rx: 2, ry: 2, width: 130, height: 12 },
      { x: 1062, y: 153, rx: 2, ry: 2, width: 100, height: 12 },

      { x: 0, y: 192, rx: 2, ry: 2, width: 32, height: 32 },
      { x: 42, y: 192, rx: 2, ry: 2, width: 112, height: 12 },
      { x: 42, y: 210, rx: 2, ry: 2, width: 55, height: 12 },
      { x: 256, y: 201, rx: 2, ry: 2, width: 148, height: 12 },
      { x: 482, y: 201, rx: 2, ry: 2, width: 56, height: 12 },
      { x: 620, y: 201, rx: 2, ry: 2, width: 112, height: 12 },
      { x: 810, y: 201, rx: 2, ry: 2, width: 130, height: 12 },
      { x: 1062, y: 201, rx: 2, ry: 2, width: 100, height: 12 },
    ],
  },
  'square-avatar-table-four-cols': {
    props: { height: 224, width: 840 },
    items: [
      { x: 0, y: 0, rx: 2, ry: 2, width: 32, height: 32 },
      { x: 42, y: 0, rx: 2, ry: 2, width: 112, height: 12 },
      { x: 42, y: 18, rx: 2, ry: 2, width: 55, height: 12 },
      { x: 256, y: 9, rx: 2, ry: 2, width: 148, height: 12 },
      { x: 482, y: 9, rx: 2, ry: 2, width: 56, height: 12 },
      { x: 657, y: 9, rx: 2, ry: 2, width: 98, height: 12 },

      { x: 0, y: 48, rx: 2, ry: 2, width: 32, height: 32 },
      { x: 42, y: 48, rx: 2, ry: 2, width: 112, height: 12 },
      { x: 42, y: 66, rx: 2, ry: 2, width: 55, height: 12 },
      { x: 256, y: 57, rx: 2, ry: 2, width: 148, height: 12 },
      { x: 482, y: 57, rx: 2, ry: 2, width: 56, height: 12 },
      { x: 657, y: 57, rx: 2, ry: 2, width: 98, height: 12 },

      { x: 0, y: 96, rx: 2, ry: 2, width: 32, height: 32 },
      { x: 42, y: 96, rx: 2, ry: 2, width: 112, height: 12 },
      { x: 42, y: 114, rx: 2, ry: 2, width: 55, height: 12 },
      { x: 256, y: 105, rx: 2, ry: 2, width: 148, height: 12 },
      { x: 482, y: 105, rx: 2, ry: 2, width: 56, height: 12 },
      { x: 657, y: 105, rx: 2, ry: 2, width: 98, height: 12 },

      { x: 0, y: 144, rx: 2, ry: 2, width: 32, height: 32 },
      { x: 42, y: 144, rx: 2, ry: 2, width: 112, height: 12 },
      { x: 42, y: 162, rx: 2, ry: 2, width: 55, height: 12 },
      { x: 256, y: 153, rx: 2, ry: 2, width: 148, height: 12 },
      { x: 482, y: 153, rx: 2, ry: 2, width: 56, height: 12 },
      { x: 657, y: 153, rx: 2, ry: 2, width: 98, height: 12 },

      { x: 0, y: 192, rx: 2, ry: 2, width: 32, height: 32 },
      { x: 42, y: 192, rx: 2, ry: 2, width: 112, height: 12 },
      { x: 42, y: 210, rx: 2, ry: 2, width: 55, height: 12 },
      { x: 256, y: 201, rx: 2, ry: 2, width: 148, height: 12 },
      { x: 482, y: 201, rx: 2, ry: 2, width: 56, height: 12 },
      { x: 657, y: 201, rx: 2, ry: 2, width: 98, height: 12 },
    ],
  },
  'webinar-table-four-cols-840': {
    props: { height: 110, width: 840 },
    items: [
      { x: 0, y: 0, rx: 2, ry: 2, width: 72, height: 40 },
      { x: 80, y: 0, rx: 2, ry: 2, width: 180, height: 16 },
      { x: 80, y: 24, rx: 2, ry: 2, width: 120, height: 16 },
      { x: 450, y: 9, rx: 2, ry: 2, width: 27, height: 16 },
      { x: 600, y: 9, rx: 2, ry: 2, width: 27, height: 16 },
      { x: 780, y: 9, rx: 2, ry: 2, width: 60, height: 16 },

      { x: 0, y: 66, rx: 2, ry: 2, width: 72, height: 40 },
      { x: 80, y: 66, rx: 2, ry: 2, width: 180, height: 16 },
      { x: 80, y: 88, rx: 2, ry: 2, width: 120, height: 16 },
      { x: 450, y: 68, rx: 2, ry: 2, width: 27, height: 16 },
      { x: 600, y: 68, rx: 2, ry: 2, width: 27, height: 16 },
      { x: 780, y: 68, rx: 2, ry: 2, width: 60, height: 16 },
    ],
  },

  'events-table-five-cols-1162': {
    props: { height: 110, width: 1162 },
    items: [
      { x: 0, y: 0, rx: 2, ry: 2, width: 72, height: 40 },
      { x: 80, y: 0, rx: 2, ry: 2, width: 180, height: 16 },
      { x: 80, y: 24, rx: 2, ry: 2, width: 120, height: 16 },
      { x: 675, y: 9, rx: 2, ry: 2, width: 55, height: 16 },
      { x: 840, y: 9, rx: 2, ry: 2, width: 27, height: 16 },
      { x: 960, y: 9, rx: 2, ry: 2, width: 27, height: 16 },
      { x: 1090, y: 9, rx: 2, ry: 2, width: 60, height: 16 },

      { x: 0, y: 66, rx: 2, ry: 2, width: 72, height: 40 },
      { x: 80, y: 66, rx: 2, ry: 2, width: 180, height: 16 },
      { x: 80, y: 88, rx: 2, ry: 2, width: 120, height: 16 },
      { x: 675, y: 68, rx: 2, ry: 2, width: 55, height: 16 },
      { x: 840, y: 68, rx: 2, ry: 2, width: 27, height: 16 },
      { x: 960, y: 68, rx: 2, ry: 2, width: 27, height: 16 },
      { x: 1090, y: 68, rx: 2, ry: 2, width: 60, height: 16 },
    ],
  },
  'textarea-sm-6': {
    props: { height: 84, width: 240 },
    items: [
      { x: 0, y: 0, rx: 2, ry: 2, width: 210, height: 12 },
      { x: 0, y: 18, rx: 2, ry: 2, width: 240, height: 12 },
      { x: 0, y: 36, rx: 2, ry: 2, width: 130, height: 12 },
      { x: 0, y: 54, rx: 2, ry: 2, width: 220, height: 12 },
      { x: 0, y: 72, rx: 2, ry: 2, width: 160, height: 12 },
    ],
  },
  'user-details': {
    props: { height: 300, width: 520 },
    items: [
      { x: 16, y: 16, rx: 2, ry: 2, width: 32, height: 32 },
      { x: 58, y: 16, rx: 2, ry: 2, width: 100, height: 12 },
      { x: 58, y: 34, rx: 2, ry: 2, width: 58, height: 12 },
      { x: 420, y: 16, rx: 2, ry: 2, width: 16, height: 16 },
      { x: 450, y: 16, rx: 2, ry: 2, width: 16, height: 16 },
      { x: 480, y: 16, rx: 2, ry: 2, width: 16, height: 16 },
      { x: 16, y: 60, rx: 2, ry: 2, width: 480, height: 12 },
      { x: 16, y: 80, rx: 2, ry: 2, width: 480, height: 12 },
      { x: 16, y: 100, rx: 2, ry: 2, width: 480, height: 12 },
      { x: 16, y: 120, rx: 2, ry: 2, width: 240, height: 12 },

      { x: 16, y: 170, rx: 2, ry: 2, width: 32, height: 32 },
      { x: 58, y: 170, rx: 2, ry: 2, width: 100, height: 12 },
      { x: 58, y: 188, rx: 2, ry: 2, width: 58, height: 12 },
      { x: 420, y: 170, rx: 2, ry: 2, width: 16, height: 16 },
      { x: 450, y: 170, rx: 2, ry: 2, width: 16, height: 16 },
      { x: 480, y: 170, rx: 2, ry: 2, width: 16, height: 16 },
      { x: 16, y: 214, rx: 2, ry: 2, width: 480, height: 12 },
      { x: 16, y: 234, rx: 2, ry: 2, width: 480, height: 12 },
      { x: 16, y: 254, rx: 2, ry: 2, width: 480, height: 12 },
      { x: 16, y: 274, rx: 2, ry: 2, width: 240, height: 12 },
    ],
  },
  'horizontal-bars': {
    props: { height: 78, width: 160 },
    items: [
      { x: 0, y: 0, rx: 2, ry: 2, width: 160, height: 16 },
      { x: 0, y: 31, rx: 2, ry: 2, width: 160, height: 16 },
      { x: 0, y: 62, rx: 2, ry: 2, width: 160, height: 16 },
    ],
  },
  'grid-box-6': {
    props: { height: 108, width: 194 },
    items: [{ x: 0, y: 0, rx: 2, ry: 2, width: 200, height: 110 }],
  },
}
